import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace CDSPVideo {
  export const form: IEventRegisterRow[] = [
    // Starter Novice
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.cdsp_starter_novice,
          options: [
            { value: "None", id: "None" },
            { value: Constants.dog_class_element_level.cdsp_level_a, id: Constants.dog_class_element_level.cdsp_level_a },
            { value: Constants.dog_class_element_level.cdsp_level_b, id: Constants.dog_class_element_level.cdsp_level_b },
            { value: Constants.dog_class_element_level.cdsp_level_c, id: Constants.dog_class_element_level.cdsp_level_c }
          ]
        }
      ]
    },
    // Novice
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.cdsp_novice,
          options: [
            { value: "None", id: "None" },
            { value: Constants.dog_class_element_level.cdsp_level_a, id: Constants.dog_class_element_level.cdsp_level_a },
            { value: Constants.dog_class_element_level.cdsp_level_b, id: Constants.dog_class_element_level.cdsp_level_b },
            { value: Constants.dog_class_element_level.cdsp_level_c, id: Constants.dog_class_element_level.cdsp_level_c }
          ]
        }
      ]
    },
    // Open
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.cdsp_open,
          options: [
            { value: "None", id: "None" },
            { value: Constants.dog_class_element_level.cdsp_level_a, id: Constants.dog_class_element_level.cdsp_level_a },
            { value: Constants.dog_class_element_level.cdsp_level_b, id: Constants.dog_class_element_level.cdsp_level_b },
            { value: Constants.dog_class_element_level.cdsp_level_c, id: Constants.dog_class_element_level.cdsp_level_c }
          ]
        }
      ]
    },
    // Utility
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.cdsp_utility,
          options: [
            { value: "None", id: "None" },
            { value: Constants.dog_class_element_level.cdsp_level_a, id: Constants.dog_class_element_level.cdsp_level_a },
            { value: Constants.dog_class_element_level.cdsp_level_b, id: Constants.dog_class_element_level.cdsp_level_b },
            { value: Constants.dog_class_element_level.cdsp_level_c, id: Constants.dog_class_element_level.cdsp_level_c }
          ]
        }
      ]
    },
    // Versatility
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          dropUp: true,
          label: Constants.dog_class_element.cdsp_versatility,
          options: [
            { value: "None", id: "None" },
            { value: Constants.dog_class_element_level.cdsp_level_a, id: Constants.dog_class_element_level.cdsp_level_a },
            { value: Constants.dog_class_element_level.cdsp_level_b, id: Constants.dog_class_element_level.cdsp_level_b },
            { value: Constants.dog_class_element_level.cdsp_level_c, id: Constants.dog_class_element_level.cdsp_level_c }
          ]
        }
      ]
    }
  ];
}
